/**
 * @description Esto no es una buena practica, POR FAVOR no seguir este ejemplo, esto es solo por un caso de emergencia.
 * @author Miguel Mendoza
 * */
export function getBodyHelp(numberRequirement: string | number, help: string) {
    return `
    <html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0">
    <title>Ayuda - SIENI</title>
    <!-- bootstrap 4.x is supported. You can also use the bootstrap css 3.3.x versions -->
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" crossorigin="anonymous">
   <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css" crossorigin="anonymous">
    <script src="https://code.jquery.com/jquery-3.3.1.min.js" crossorigin="anonymous"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js"></script>
    <!-- bootstrap.min.js below is needed if you wish to zoom and preview file content in a detail modal
        dialog. bootstrap 4.x is supported. You can also use the bootstrap js 3.3.x versions. -->
    <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.bundle.min.js" crossorigin="anonymous"></script>
    <!-- the main fileinput plugin file -->
    <style type="text/css">
        .footer {
            position: fixed;
            clear:both;
            bottom: 0;
            text-align:center;
            background-color: #0068A9;
            height: 50px;
            width: 100%;
        }
        .img-logo {
         /* display: block; */
          max-width:80px;
          max-height:80px;
          width: auto;
          height: auto;

        }
        .img-footer {
         /* display: block; */
          max-width:40px;
          max-height:40px;
          width: auto;
          height: auto;
          margin-top: 7.5px;

        }
        .header{
            height: 130px;
            background-image: url(http://admin.goalempresas.com/img/help_header.jpg);
            font-size: -webkit-xxx-large;
            color: white;
            display:flex;
            justify-content:center;
            align-items:center
        }

        .header h6{
            font-size:4rem;
            margin-left:30px;
        }
        .container{
            padding:20px 0;
            margin-bottom:50px;
            text-align: justify;
        }
    </style>

</head>
<body>
    <div class="flex-center position-ref full-right">
        <div class="content">
        <div class="title m-b-md header"  >
        <img class="img-logo" src="http://admin.goalempresas.com/img/help_logo.png"/>
            <h6>
            ${numberRequirement}
            </h6>
            </div>
            <div class="container">
                ${help}
            </div>
            <div class="footer" align="center"><img class="img-footer" src="http://admin.goalempresas.com/img/logo_white.png"/></div>
        </div>

    </div>
</body>
<script>
$(document).ready(function () {
    window.resizeTo(screen.availWidth, screen.availHeight);
    window.moveTo(0,0);
});
</script>
</html>


    `;
}
